import { Text, Center, Stack } from "@mantine/core";
import { IconLock } from "@tabler/icons-react";
import useUserStore from "@/modules/users/store";

interface AdminGuardProperties {
  children: React.ReactNode;
}

const AdminGuard = ({ children }: AdminGuardProperties) => {
  const colaborador = useUserStore((state) => state.colaborador);
  const isAdminLicenciada = colaborador?.adminLicenciada === true;

  if (!isAdminLicenciada) {
    return (
      <Center style={{ height: "50vh" }}>
        <Stack align="center" gap="md">
          <IconLock size={48} color="var(--mantine-color-gray-6)" />
          <Text size="lg" c="dimmed">
            Acesso negado
          </Text>
          <Text size="sm" c="dimmed" ta="center">
            Esta página requer privilégios de administrador de licenciadas
          </Text>
        </Stack>
      </Center>
    );
  }

  return <>{children}</>;
};

export default AdminGuard;
